import type { FocWsTourStepDef } from './focWsTourSteps';

/**
 * Position workspace registers scroll helpers for the FOC 13.1 tour.
 */
export type FocWsTourApi = {
  scrollToTour?: (tour: string) => void;
};

let api: Partial<FocWsTourApi> = {};

export function registerFocWsTourApi(
  partial: Partial<FocWsTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof FocWsTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getFocWsTourApi(): Partial<FocWsTourApi> {
  return api;
}

export function prepareFocWsStep(def: FocWsTourStepDef | undefined) {
  if (!def?.tour) return;
  getFocWsTourApi().scrollToTour?.(def.tour);
}

export function resetFocWsTourBridgeForTests() {
  api = {};
}
